import { render, staticRenderFns } from "./FichaTecnicaTarefaHeader.vue?vue&type=template&id=08384d1d&scoped=true"
import script from "./FichaTecnicaTarefaHeader.vue?vue&type=script&lang=js"
export * from "./FichaTecnicaTarefaHeader.vue?vue&type=script&lang=js"
import style0 from "./FichaTecnicaTarefaHeader.vue?vue&type=style&index=0&id=08384d1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08384d1d",
  null
  
)

export default component.exports